export const projects = [
  {
    _id: "1",
    title: "Medical ChatBot",
    typo: "FullStack",
    content: "A MERN-based medical chatbot for symptom guidance.",
    category: "FullStack",
    image: "https://i.ibb.co/n1pT7f2/Chat-Bot-App.png",
    link: "https://google.com",
  },
  {
    _id: "2",
    title: "FeedForward",
    typo: "FullStack",
    content: "A community-driven feedback platform.",
    category: "FullStack",
    image: "https://i.ibb.co/Mk7sZys/feedforward.jpg", // domain-relevant (feedback system)
    link: "https://github.com/chintan0513/FeedForward",
  },
  {
    _id: "3",
    title: "PATH",
    typo: "FullStack",
    content: "Personal Academic Tracker using MERN stack.",
    category: "FullStack",
    image: "https://i.ibb.co/SdH1V0G/education.jpg", // education domain
    link: "https://github.com/chintan0513/PATH",
  },
  {
    _id: "4",
    title: "FoodNexus",
    typo: "FullStack",
    content: "A food recipe sharing app built with MERN stack.",
    category: "FullStack",
    image: "https://i.ibb.co/dkyGDtb/foodnexus.jpg", // food sharing domain
    link: "https://github.com/chintan0513/FoodNexus",
  },
  {
    _id: "5",
    title: "SustainaConnect",
    typo: "FullStack",
    content: "Connecting people to sustainability initiatives.",
    category: "FullStack",
    image: "https://i.ibb.co/y4whYP0/sustainability.jpg", // sustainability domain
    link: "https://github.com/chintan0513/SustainaConnect",
  },
  {
    _id: "6",
    title: "Kalakari",
    typo: "Frontend",
    content: "Art portfolio frontend site built with HTML, CSS, JS.",
    category: "Frontend",
    image: "https://i.ibb.co/VHWc4pk/Kalakari.png",
    link: "https://kalakari.vercel.app/",
  },
  {
    _id: "7",
    title: "ToDo List",
    typo: "Frontend",
    content: "A clean ToDo app using HTML, CSS, and JS.",
    category: "Frontend",
    image: "https://i.ibb.co/ZJZmF7v/To-Do-List.png",
    link: "https://todo-list-iota-nine.vercel.app/",
  },
  {
    _id: "8",
    title: "Travel App",
    typo: "Frontend",
    content: "Frontend travel planner app with responsive design.",
    category: "Frontend",
    image: "https://i.ibb.co/DgHTYYm/TravelGo.png",
    link: "https://travgo.netlify.app/",
  },
  {
    _id: "9",
    title: "Recipe App",
    typo: "Frontend",
    content: "Recipe listing app with API integration.",
    category: "Frontend",
    image: "https://i.ibb.co/VCRxT1J/Recipe-API.png",
    link: "https://github.com/chintan0513/recipe",
  },
  {
    _id: "10",
    title: "Potter DB",
    typo: "Cloud & Open Source",
    content: "Contributed to Potter DB, an open-source Harry Potter DB.",
    category: "Cloud & Open Source",
    image: "https://i.ibb.co/Yd4Xfkd/Potter-DB-Home.png",
    link: "https://potterdb.com/",
  },
  {
    _id: "11",
    title: "Loan Approval System",
    typo: "Data",
    content: "Loan eligibility analysis using Python and SQL.",
    category: "Data",
    image: "https://i.ibb.co/0yWrLMv/data-analysis.jpg", // data engineering domain
    link: "https://github.com/chintan0513/LoanEligibility",
  },
];

export default projects;

export const buttons = [
  { name: "All", value: "all" },
  { name: "FullStack", value: "FullStack" },
  { name: "Frontend", value: "Frontend" },
  { name: "Cloud & Open Source", value: "Cloud & Open Source" },
  { name: "Data Analysis / Engineering", value: "Data" },
];
